module.exports = __webpack_public_path__ + "assets/img/step3.bb08aa9b.png";